export default "__VITE_ASSET__DcYr51Nf__"